'use client';

import React from 'react';
import { AvatarGroup, Avatar as MUIAvatar, Typography } from '@mui/material';
import { getInstructorName } from '../../utils/common';

export interface AvatarProps {
  instructors: {
    name: string;
    avatarUrl: string;
  }[];
  courseType?: string;
  borderColor?: string;
}

const Avatar: React.FC<AvatarProps> = ({ instructors, borderColor }) => {
  return (
    <div className="flex gap-x-2 items-center">
      <AvatarGroup max={3}>
        {Array.isArray(instructors) &&
          instructors.map((instructor, i) => (
            <MUIAvatar
              key={`${i}-${instructor.name}`}
              src={instructor.avatarUrl}
              alt={instructor.name}
              sx={{
                borderColor: `${borderColor} !important`,
              }}
            />
          ))}
      </AvatarGroup>
      <Typography variant="caption-500">{getInstructorName(instructors)}</Typography>
    </div>
  );
};

export default Avatar;
